import type { RootStateOrAny } from 'react-redux';
import { useSelector } from 'react-redux';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { IArticle, ICategoryByGroupDetail } from 'src/interface';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import {
	actionGetCategoryDetail,
	actionGetCategoryObatDetail,
} from 'src/redux/actions/categoryByGroup';

const HeadC = dynamic(() => import('src/components/Head'));
const InfoObatLayout = dynamic(() => import('src/components/Layout/InfoObat'));
const SearchObat = dynamic(() => import('src/containers/InfoObat/Search'));
const TabObat = dynamic(() => import('src/containers/InfoObat/Tab'));

const InfoObatCategoryPage = () => {
	const { detail }: { detail: ICategoryByGroupDetail } = useSelector(
		(state: RootStateOrAny) => state.categoryByGroup,
	);
	const obatName = detail.name ?? 'Obat';

	return (
		<>
			<HeadC
				title={`Informasi Obat Berdasarkan ${obatName}`}
				description={`Ketahui informasi direktori obat berdasarkan ${obatName}
				terlengkap. Cari tahu obat berdasarkan keluhan lainnya hanya di KlikDokter.`}
			/>
			<InfoObatLayout
				header={<SearchObat />}
				adSource="obat"
				adTarget={[['channel', ['obat', detail.slug]]]}
			>
				<TabObat activeTab="keluhan" isCategory />
			</InfoObatLayout>
		</>
	);
};

export async function getStaticPaths() {
	return {
		paths: [],
		fallback: 'blocking',
	};
}

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
	(store) => async (context: any) => {
		const { category } = context.params;
		let isError: boolean = false;

		await store.dispatch(actionGetMenu());
		await store.dispatch(actionGetFooterMenu());

		try {
			await store.dispatch(actionGetCategoryDetail(category));
			await store.dispatch(actionGetCategoryObatDetail(category, 'obat'));
		} catch (err: any) {
			isError = true;
		}

		const obat: IArticle = store.getState().categoryByGroup.detail_obat;
		const detail: ICategoryByGroupDetail = store.getState().categoryByGroup.detail;

		if ((!category || !obat) && isError) return { notFound: true };

		return {
			props: {
				card: true,
				isWhiteBackground: true,
				pageHeaderContent: {
					title: 'Obat',
					hideHeadingTitle: true,
					breadcrumbs: [{ label: 'Obat', navigatePath: '/obat' }, { label: detail.name ?? 'Obat' }],
				},
			},
			revalidate: g.REVALIDATE_EXP_ARTICLE,
		};
	},
);

export default InfoObatCategoryPage;
